import bike from '../commuteIcons/bike.svg'
import bolt from '../commuteIcons/bolt.svg'
import booknDrive from '../commuteIcons/booknDrive.svg'
import callABike from '../commuteIcons/callABike.svg'
import cambio from '../commuteIcons/cambio.svg'
import deer from '../commuteIcons/deer.svg'
import dott from '../commuteIcons/dott.svg'
import free2move from '../commuteIcons/free2move.svg'
import freenow from '../commuteIcons/freenow.svg'
import kvb from '../commuteIcons/KVB.svg'
import lime from '../commuteIcons/lime.svg'
import limeBike from '../commuteIcons/limeBike.svg'
import miles from '../commuteIcons/miles.svg'
import mvg from '../commuteIcons/mvg.svg'
import nextbike from '../commuteIcons/nextbike.svg'
import regioRadStuttgart from '../commuteIcons/regioRadStuttgart.svg'
import sbahn from '../commuteIcons/sbahn.svg'
import shareNow from '../commuteIcons/shareNow.svg'
import sixt from '../commuteIcons/sixt.svg'
import stadtrad from '../commuteIcons/stadtrad.svg'
import taxide from '../commuteIcons/taxide.svg'
import tier from '../commuteIcons/tier.svg'
import ubahn from '../commuteIcons/ubahn.svg'
import uber from '../commuteIcons/uber.svg'
import voi from '../commuteIcons/voi.svg'
import walk from '../commuteIcons/walk.svg'

const CITY_COORDS = {
  hamburg: { lat: 53.5529, lon: 10.005 },
  berlin: { lat: 52.5251, lon: 13.3694 },
  munich: { lat: 48.1402, lon: 11.5586 },
  frankfurt: { lat: 50.1071, lon: 8.6638 },
  stuttgart: { lat: 48.7855, lon: 9.1829 },
  cologne: { lat: 50.9423, lon: 6.9581 },
}
const iconMap = {
  sixt,
  free2move,
  miles,
  cambio,
  uber,
  freenow,
  taxide,
  dott,
  voi,
  lime,
  bolt,
  stadtrad,
  booknDrive,
  tier,
  nextbike,
  mvg,
  regioRadStuttgart,

  kvb,
  bike,
  limeBike,
  callABike,
  shareNow,
  deer,
  walk,
}

// ✅ Updated function
function iconPath(name) {
  const key = name.toLowerCase()
  return iconMap[key] || walk // fallback to walk icon if not found
}
function randomWalkTime(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

function randomNearbyCoords({ lat, lon }, delta = 0.005) {
  return {
    lat: +(lat + (Math.random() * 2 - 1) * delta).toFixed(6),
    lon: +(lon + (Math.random() * 2 - 1) * delta).toFixed(6),
  }
}

export function getMobilityServicesForCity(cityName) {
  const center = CITY_COORDS[cityName.toLowerCase()]
  if (!center) return null

  const services = {
    hamburg: {
      carSharing: ['sixt', 'free2move', 'miles'],
      taxiServices: ['uber', 'freenow', 'taxide'],
      scooterSharing: ['dott', 'voi', 'lime'],
      bikeSharing: ['stadtrad'],
    },
    berlin: {
      carSharing: ['sixt', 'miles', 'bookndrive'],
      taxiServices: ['uber', 'freenow'],
      scooterSharing: ['tier', 'voi', 'lime'],
      bikeSharing: ['nextbike'],
    },
    munich: {
      carSharing: ['cambio', 'bookndrive'],
      taxiServices: ['uber', 'taxide'],
      scooterSharing: ['tier', 'voi'],
      bikeSharing: ['nextbike', 'mvg'],
    },
    frankfurt: {
      carSharing: ['free2move', 'bookndrive'],
      taxiServices: ['uber', 'freenow'],
      scooterSharing: ['tier'],
      bikeSharing: ['nextbike'],
    },
    stuttgart: {
      carSharing: ['cambio', 'bookndrive'],
      taxiServices: ['taxide'],
      scooterSharing: ['tier'],
      bikeSharing: ['regioradstuttgart'],
    },
    cologne: {
      carSharing: ['cambio'],
      taxiServices: ['freenow'],
      scooterSharing: ['lime', 'voi'],
      bikeSharing: ['kvb'],
    },
  }[cityName.toLowerCase()]

  const format = (names, minTime, maxTime) =>
    names.map(name => ({
      name: name.replace(/^\w/, c => c.toUpperCase()).replace(/([a-z])([A-Z])/g, '$1 $2'),
      logo: iconPath(name.toLowerCase()),
      walkTime: randomWalkTime(minTime, maxTime),
      coordinates: randomNearbyCoords(center),
    }))

  return {
    carSharing: format(services.carSharing, 3, 9),
    taxiServices: format(services.taxiServices, 1, 6),
    scooterSharing: format(services.scooterSharing, 2, 5),
    bikeSharing: format(services.bikeSharing, 1, 4),
  }
}
